import React, { useEffect } from 'react';

import { SomaIcon } from "@soma/react";
import { SomaTooltip } from "@soma/react";

import { Row } from 'xpi-black-ui/Base/Grid';
import Slider from 'xpi-black-ui/Base/Slider';
import { P } from 'xpi-black-ui/Base/Typography';
import KeyValue from 'xpi-black-ui/Common/KeyValue';

import Skeleton from 'components/Common/Skeleton';

import { convertToCurrency } from 'utils/helpers';

function Price({ priceInfo, setPriceInfo, loadingPrice }) {
  const  { commissionSelected, commissionMinimum, commissionMaximum, endPrice, indicativePrice } = priceInfo;

  const updatePrice = (field, value) => {
    setPriceInfo({
      ...priceInfo,
      [field]: value,
    });
  };

  useEffect(() => {
    if (indicativePrice && commissionSelected) {
      updatePrice('endPrice', (indicativePrice + commissionSelected));
    }
  }, [commissionSelected]);

  const setCommissionSelected = (e) => {
    updatePrice('commissionSelected', Number(e[0]));
  };

  const RenderLoadingPrice = () => (
    <>
      <KeyValue
        column
        style={{ width: '283px' }}
        title="Selecione a comissão"
        value={<Skeleton width="90px" height="24px" />}
      />
      <KeyValue
        column
        style={{ width: '107px' }}
        title="Preço indicativo"
        value={<Skeleton width="90px" height="24px" />}
      />
      <KeyValue
        column
        title="Comissão"
        value={<Skeleton width="90px" height="24px" />}
      />
      <KeyValue
        column
        title="Preço operação"
        value={<Skeleton width="90px" height="24px" />}
      />
    </>
  );

  return (
    <>
      {loadingPrice
        ? <RenderLoadingPrice />
        : (
          <>
            <KeyValue
              column
              style={{ width: '283px' }}
              title="Selecione a comissão"
              value={
                commissionMinimum
                ? (
                  <Row className="commission">
                    <P>Min: {convertToCurrency(commissionMinimum)}</P>
                    <Slider
                      step={commissionSelected}
                      onUpdate={setCommissionSelected}
                      range={{ min: commissionMinimum, max: commissionMaximum }}
                    />
                    <P>Max: {convertToCurrency(commissionMaximum)}</P>
                  </Row>
                )
                : '-'
              }
            />
            <KeyValue
              column
              style={{ width: '107px' }}
              title="Preço indicativo"
              value={indicativePrice ? convertToCurrency(indicativePrice) : '-'}
            />
            <KeyValue
              column
              title="Comissão"
              value={commissionSelected ? convertToCurrency(commissionSelected) : '-'}
            />
            <KeyValue
              column
              title={(
                <>
                  <SomaTooltip
                    inverse
                    position="top"
                    aria-label="Ativo"
                    style={{ display: 'flex', alignItems: 'center' }}
                    label="O preço da operação contém somente o custo da estrutura de opções."
                  >
                    <P style={{ marginRight: '8px' }}>Preço operação</P>
                    <SomaIcon icon="info" size="sm" color="#FFC709" />
                  </SomaTooltip>
                </>
              )}
              value={endPrice ? convertToCurrency(endPrice) : '-'}
            />

          </>
      )}
    </>
  );
}

export default Price;
